import React, { useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader,
  CardFooter,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { get, post } from '../../helpers/api_helper';

function Reprint(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [remoteData, setRemoteData] = React.useState(null);

  const { itemId } = useParams();

  const shelfLabelRef = useRef(null);
  const stockIdRef = useRef(null);
  const lotRef = useRef(null);
  const serialRef = useRef(null);

  const fetchRemoteDataByItemId = async () => {
    try {
      const response = await get(`/api/burnsville/inventoryByItemId/${itemId}`);
      setRemoteData(response);
      stockIdRef.current.value = response.stock_id;
    } catch (error) {
      toastr.error(props.t('Error fetching remote inventory data'));
    }
  };

  const fetchRemoteDataByStockId = async (stockId) => {
    try {
      const response = await get(`/api/burnsville/inventoryByStockId/${stockId}`);
      setRemoteData(response);
      stockIdRef.current.value = response.stock_id;
    } catch (error) {
      toastr.error(props.t('Error fetching remote inventory data'));
    }
  };

  useEffect(() => {
    if (itemId) {
      fetchRemoteDataByItemId();
      document.title = props.t(`Reprint Shelf Label | item ID ${itemId}`);
    } else {
      document.title = props.t('Reprint Shelf Label');
    }

    shelfLabelRef.current.focus();
  }, [itemId]);

  const print = async () => {
    try {
      await post(`/api/burnsville/printDZLabel/${remoteData.stock_id}`, {
        lot: lotRef.current.value,
        serial: serialRef.current.value,
        part_number: remoteData.part_number,
        qty: 1,
      });

      if (itemId === null) setRemoteData(null);
      lotRef.current.value = '';
      serialRef.current.value = '';
      shelfLabelRef.current.value = '';
      shelfLabelRef.current.focus();
    } catch (error) {
      toastr.error(props.t('Error printing label.'), error.message);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="4">
            <Card>
              <CardHeader className="h5">{props.t('Reprint Shelf Label')}</CardHeader>
              <CardBody>
                <div className="mb-3">
                  <label htmlFor="shelfLabel" className="form-label">{props.t('Shelf Label')}</label>
                  <input
                    type="text"
                    ref={shelfLabelRef}
                    className="form-control"
                    id="shelfLabel"
                    placeholder={props.t('Scan shelf label into here...')}
                    onKeyDown={async (e) => {
                      if (e.key === 'Enter') {
                        const value = e.target.value.trim();
                        if (value) {
                          const stockid = value.substring(1, 9).trim();
                          const serial = value.substring(15, 75).trim();
                          const lot = value.substring(75).trim();

                          if (itemId === undefined) {
                            await fetchRemoteDataByStockId(stockid);
                            stockIdRef.current.value = stockid;
                          }

                          lotRef.current.value = lot;
                          serialRef.current.value = serial;

                          if (remoteData !== null) {
                            print();
                          }
                        } else {
                          toastr.error(props.t('Shelf label not recognized.'));
                        }
                      }
                    }}
                  />
                  <div className="text-muted mt-1">
                    {props.t('Populates the fields below by extracting lot and serial.')}
                    <br />
                    <strong>{props.t('Only populates Stock ID if none set.')}</strong>
                  </div>
                </div>

                <Row>
                  <Col xs={6}>
                    <div className="mb-3">
                      <label htmlFor="stockId" className="form-label">{props.t('Stock ID')}</label>
                      <input type="text" ref={stockIdRef} className="form-control" readOnly id="stockId" />
                    </div>
                  </Col>
                  <Col xs="6">
                    {remoteData && (
                      <div className="hstack gap-2 mt-2">
                        <img src={`/api/items/thumbnail/${remoteData.sj_sku}`} alt={remoteData.part_number} className="img-thumbnail" style={{ width: '50px', height: '50px' }} />
                        <Link to={`/item/${remoteData.sj_sku}`}>{props.t(`${remoteData.part_number}`)}</Link>
                      </div>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col xs={6}>
                    <div className="mb-3">
                      <label htmlFor="lot" className="form-label">{props.t('Lot')}</label>
                      <input type="text" ref={lotRef} className="form-control" id="lot" placeholder={props.t('Lot number')} />
                    </div>
                  </Col>
                  <Col xs="6">
                    <div className="mb-3">
                      <label htmlFor="serial" className="form-label">{props.t('Serial')}</label>
                      <input type="text" ref={serialRef} className="form-control" id="serial" placeholder={props.t('Serial')} />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-primary btn-soft-warning text-dark" onClick={print}>{props.t('Print')}</button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Reprint.defaultProps = {
  t: (x) => (x),
};

Reprint.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Reprint));
